import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import TechnicalInfoService from '@/services/CatalogServices/TechnicalInfoService';
import { extractError } from '@/helpers/extractApiError';
import { upseartItem } from '@/helpers/CRUD';
import { createTableHeader } from '../create/createSlice';

const model = {
    data: [],
    totalItems: 0,
    loading: false,
    error: null,
};

export const getTableHeaderList = createAsyncThunk(
    'table-header/getTableHeaderList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await TechnicalInfoService.getTableHeaderList(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const tableHeaderListSlice = createSlice({
    name: 'tableHeaderList',
    initialState: model,
    reducers: {},
    extraReducers: (builder) => {
        // table header list
        builder.addCase(getTableHeaderList.pending, (state) => {
            state.loading = true;
        }).addCase(getTableHeaderList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data;
            state.totalItems = action.payload.total;
        }).addCase(getTableHeaderList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Handle creating and updating table header
        builder.addCase(createTableHeader.fulfilled, (state, action) => {
            state.data = upseartItem(state.data, action.payload);
            state.totalItems = action.meta.arg.table_header_id
                ? state.totalItems
                : state.totalItems + 1;
        });
    },
});

export default tableHeaderListSlice.reducer;
